'use client';
/* Built In Imports */
'use client';
import { usePathname, useSearchParams } from 'next/navigation';

/* External Imports */
import { Box, useBreakpointValue } from '@chakra-ui/react';
import config from '@config';
import { FaFacebook, FaLinkedin, FaTwitter, FaWhatsapp } from 'react-icons/fa';
import { GrMail } from 'react-icons/gr';
import {
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

/**
 *
 * @param {Object} param0
 * @returns
 */
const EmbedIcons = ({
  display = 'flex',
  justifyContent = 'center',
  alignItems = 'center',
  flexDirection = 'row',
  gap = { base: '1rem', md: '2rem', lg: '1.8rem' },
  url,
  iconColor,
}) => {
  // const router = useRouter();
  const pathname = usePathname(); // Gets the base path
  const searchParams = new URLSearchParams(useSearchParams().toString()); // Gets the query parameters
  const pageUrl = `${config.BASE_PATH}${pathname}?${searchParams.toString()}`; // Constructs the full URL
  const iconSize = useBreakpointValue({ base: 24, md: 32 });

  return (
    <Box
      py={{ base: '30px', md: '60px' }}
      pt={{ base: '30px', md: '30px' }}
      display={display}
      justifyContent={justifyContent}
      alignItems={alignItems}
      flexDirection={flexDirection}
      gap={gap}
      marginX={{ base: 'auto', lg: 'auto' }}
    >
      <WhatsappShareButton url={pageUrl} title={''} separator=":: ">
        <FaWhatsapp size={iconSize} color={iconColor} />
      </WhatsappShareButton>

      <FacebookShareButton url={pageUrl}>
        <FaFacebook size={iconSize} color={iconColor} />
      </FacebookShareButton>

      <TwitterShareButton url={pageUrl}>
        <FaTwitter size={iconSize} color={iconColor} />
      </TwitterShareButton>

      <LinkedinShareButton url={pageUrl}>
        <FaLinkedin size={iconSize} color={iconColor} />
      </LinkedinShareButton>

      <EmailShareButton url={pageUrl}>
        <GrMail size={iconSize} color={iconColor} />
      </EmailShareButton>
    </Box>
  );
};

export default EmbedIcons;
